import { LinkedModelList } from "./linkedModelList";
import { LinkNewModel } from "./linkNewModel";
import { LinkPrimaryModel } from "./linkPrimaryModel";
import "./linkedModelCard.css";

type Props = {
    modelId: string;
    projectId: string;
};

export const LinkedModelsDockingPanelContent = ({ modelId, projectId }: Props) => {
    return (
        <div className="linked-model-panel-content">
            <div className="linked-model-panel">
                <LinkedModelList />

                <div className="linked-model-panel__actions">
                    <LinkPrimaryModel modelId={modelId} projectId={projectId} />
                    <LinkNewModel modelId={modelId} projectId={projectId} />
                </div>
            </div>
        </div>
    );
};
